var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08008 2.06689V25.1053H29.9201V2.06689H4.08008ZM11.6145 3.50849H16.2929V5.87484H11.6145V3.50849ZM21.4337 12.8381C22.005 13.1917 22.005 14.0076 21.4337 14.3612L14.8241 18.4957C14.2257 18.8765 13.4369 18.4412 13.4369 17.7341V9.49249C13.4369 8.78533 14.2256 8.35009 14.8241 8.73089L21.4337 12.8381ZM10.1729 23.6909H5.49448V21.3245H10.1729V23.6909ZM10.1729 5.84769H5.49448V3.48134H10.1729V5.84769ZM16.2929 23.6909H11.6145V21.3245H16.2929V23.6909ZM22.3857 23.6909H17.7073V21.3245H22.3857V23.6909ZM22.3857 5.84769H17.7073V3.48134H22.3857V5.84769ZM28.5057 23.6909H23.8273V21.3245H28.5057V23.6909ZM28.5057 5.84769H23.8273V3.48134H28.5057V5.84769Z",
    fill: "#BEBEBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.4186a9a3e43e0dc920c0d83700b16376.svg";
export { ForwardRef as ReactComponent };